// Fires Attentive's sign-up unit when `.attentive-signup` is clicked.
(function () {
  'use strict';

  const DESKTOP_MIN_WIDTH = 760;
  const RETRY_DELAY_MS = 500;
  const MAX_ATTEMPTS = 10; // ~5s total, in case the Attentive tag loads slowly.

  function getTriggerArgs(el) {
    const isDesktop = globalThis.innerWidth >= DESKTOP_MIN_WIDTH;
    const creative =
      (isDesktop
        ? el.dataset.attentiveCreativeDesktop
        : el.dataset.attentiveCreativeMobile) ||
      el.dataset.attentiveCreative ||
      null;

    const filter = el.dataset.attentiveFilter || null;
    const clientId = el.dataset.attentiveClientId || null;
    const email = el.dataset.attentiveEmail || null;

    // No overrides supplied on the link — use Attentive's generic custom
    // trigger (creative configured in the Attentive dashboard). Passing an
    // array of nulls prevents the creative from showing, so return no args.
    if (!filter && !clientId && !email && !creative) {
      return [];
    }

    return [
      filter,
      clientId,
      email,
      // Attentive expects the creative_id as a number (matching legacy setup).
      creative && /^\d+$/.test(creative) ? Number(creative) : creative,
    ];
  }

  function fireTrigger(args, attempt) {
    if (globalThis.__attentive && typeof globalThis.__attentive.trigger === 'function') {
      globalThis.__attentive.trigger(...args);
      return;
    }

    // Attentive tag may not have finished loading yet; retry on a delay.
    if (attempt < MAX_ATTEMPTS) {
      setTimeout(function () {
        fireTrigger(args, attempt + 1);
      }, RETRY_DELAY_MS);
    }
  }

  function onClick(event) {
    const el = event.target.closest('.attentive-signup');
    if (!el) {
      return;
    }
    event.preventDefault();
    fireTrigger(getTriggerArgs(el), 0);
  }

  function init() {
    // Delegated handler so it works even if the link is rendered
    // after this script runs (sections hydrating, editor re-render, etc.).
    document.addEventListener('click', onClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
